import { useSelector } from 'react-redux';
import { IRootReducerState } from 'store/store';
import { IConfigurationQuestion } from 'types/ConfigurationQuestion.types';
import { ConfigurationQuestionRow } from './ConfigurationQuestionRow';

// Renders all active configuration (extra price) questions for the model in the
// customer-facing configurator. Each question is shown after the model's regular
// questions. Selections are persisted in redux (selectedConfigurationAnswers).
export const ConfigurationQuestionsRows = () => {
  const extraPriceQuestions: IConfigurationQuestion[] = useSelector(
    (state: IRootReducerState) => state.modelInfo.extraPriceQuestions
  );

  if (!extraPriceQuestions?.length) {
    return null;
  }

  return (
    <>
      {extraPriceQuestions.map((question) => (
        <ConfigurationQuestionRow
          key={question.slug}
          question={question}
          showBorder={true}
        />
      ))}
    </>
  );
};
